{
    "title": "Additional Metric Analysis Output",
    "description": "JSON schema of ancillary input data to timeSeries module",
    "version": "0.14.0",
    "type": "array",
    "modules": {
        "timeSeries": {
            "required": false
        }
    },
    "items": {
        "type": "object",
        "required": ["Param", "Value"],
        "properties": {
            "StudyID": {
                "title": "Study ID",
                "description": "Unique study identifier",
                "type": "string",
                "required": false,
                "key": true
            },
            "MetricID": {
                "title": "Metric ID",
                "description": "Unique workflow identifier",
                "type": "string",
                "required": false,
                "key": true
            },
            "Param": {
                "title": "Analysis Parameter",
                "description": "Analysis parameter",
                "type": "string",
                "required": true,
                "key": true
            },
            "Value": {
                "title": "Analysis Result",
                "description": "Analysis result",
                "type": "number",
                "required": true,
                "key": false
            },
            "SnapshotDate": {
                "title": "Snapshot Date",
                "description": "Date of data refresh",
                "type": "string",
                "required": false,
                "key": false
            }
        }
    }
}
